module.exports = __webpack_public_path__ + "static/plant.6d5d62eb.jpg";